import type { Articulation, DynamicMark } from '@/music/score/types';

const ARTICULATIONS: { value: Articulation; label: string; symbol: string }[] = [
  { value: 'staccato', label: 'Staccato', symbol: '·' },
  { value: 'tenuto', label: 'Tenuto', symbol: '—' },
  { value: 'accent', label: 'Accent', symbol: '>' },
  { value: 'marcato', label: 'Marcato', symbol: '^' },
];

/** The same authored note/rest controls live in the desktop and phone popovers. */
export function ScoreExpressionControls({
  rest,
  articulations = [],
  dynamic,
  onToggleArticulation,
  onDynamic,
}: {
  rest: boolean;
  articulations?: readonly Articulation[];
  dynamic?: DynamicMark;
  onToggleArticulation: (articulation: Articulation) => void;
  onDynamic: (dynamic: DynamicMark | undefined) => void;
}) {
  return (
    <div
      className="score-expression-controls"
      role="group"
      aria-label="Expression"
      style={{ display: 'grid', gap: '0.5rem', maxWidth: '20rem' }}
    >
      {!rest && (
        <div
          role="group"
          aria-label="Articulations"
          style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.25rem' }}
        >
          {ARTICULATIONS.map(({ value, label, symbol }) => (
            <button
              type="button"
              className="btn btn-sm"
              key={value}
              aria-label={label}
              aria-pressed={articulations.includes(value)}
              onClick={() => onToggleArticulation(value)}
            >
              <span aria-hidden="true">{symbol}</span> {label}
            </button>
          ))}
        </div>
      )}
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        Dynamic
        <select
          aria-label="Dynamic marking"
          value={dynamic ?? ''}
          onChange={(event) =>
            onDynamic((event.target.value || undefined) as DynamicMark | undefined)
          }
        >
          <option value="">Inherit</option>
          {(['pp', 'p', 'mp', 'mf', 'f', 'ff'] as const).map((mark) => (
            <option key={mark} value={mark}>
              {mark}
            </option>
          ))}
        </select>
      </label>
      <small>Dynamic continues until another marking.</small>
    </div>
  );
}
